import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer-container">
      <hr width="300" />
      <p> &copy; 2021 Nicolás Alanis </p>
    </div>
  );
};

export default Footer;
